import React, { useState } from 'react';
import { Container, Typography, Button } from '@mui/material';
import ConnectionModal from '../../Components/Modals/ConnectionsModal';
import ConnectionsList from '../../Components/Lists/ConnectionsList';
import { GET_COMPANY_CONNECTIONS } from '../../graphql/queries';
import { useQuery } from '@apollo/client';

const MyConnections: React.FC = () => {
  const [connections, setConnections] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { data, loading, error, refetch } = useQuery(GET_COMPANY_CONNECTIONS);

  const handleAddConnection = async (connection: string) => {
    setConnections([...connections, connection]);
    setIsModalOpen(false);
    await refetch();
  };  


  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        My Connections
      </Typography>
      {/* Display Connections List */}
      {!loading && !error && (
        <ConnectionsList
          connections={data?.companyConnections || []}
        />
      )}
      <Button variant="contained" color="primary" onClick={() => setIsModalOpen(true)}>
        Add Connection
      </Button>
      <ConnectionModal open={isModalOpen} onClose={() => setIsModalOpen(false)} onAddConnection={handleAddConnection} />
    </Container>
  );
};

export default MyConnections;
